import { NotificationContext } from '@app/models/enums'
import { Notification } from '@app/models/Notification'
import { ApplicationState } from '@app/store'
import { Store } from 'redux'
import io, { Socket } from 'socket.io-client'

let storeInstance: Store<ApplicationState> | undefined
let socket: Socket | undefined
let token: string | undefined

enum Events {
  NewNotification = 'new-notification',
  Reconnect = 'reconnect',
  Subscribe = 'subscribe',
  UpdateNotification = 'update-notification',
}

export enum ActionTypes {
  NewNotificationReceived = 'NOTIFICATIONS_SOCKET::NEW_NOTIFICATION_RECEIVED',
  UpdateNotificationReceived = 'NOTIFICATIONS_SOCKET::UPDATE_NOTIFICATION_RECEIVED',
}

export interface INewNotificationReceivedAction {
  context: NotificationContext
  notification: Notification
  type: ActionTypes.NewNotificationReceived
}

export interface IUpdateNotificationReceivedAction {
  context: NotificationContext
  notification: Notification
  type: ActionTypes.UpdateNotificationReceived
}

export function prepareNotificationsSocket(store: Store<ApplicationState>) {
  storeInstance = store
}

export function connect(accessToken: string) {
  token = accessToken

  socket = io(`${window.location.origin}:7300/notifications`)

  if (socket) {
    socket
      .on(Events.NewNotification, onNewNotification)
      .on(Events.UpdateNotification, onUpdateNotification)
  } else {
    console.error('Failed to create socket connection for notifications')
  }

  subscribe()
}

export function disconnect() {
  if (socket) {
    socket.disconnect()
    socket = undefined
  }
}

export function joinUserChannel(accessToken: string) {
  token = accessToken
  if (socket) {
    subscribe()
  }
}

function onNewNotification(payload: any) {
  if (payload.id && payload.context && storeInstance) {
    const notification = Notification.fromJS(payload)
    storeInstance.dispatch({
      context: notification.context,
      notification,
      type: ActionTypes.NewNotificationReceived,
    } satisfies INewNotificationReceivedAction)
  }
}

function onUpdateNotification(payload: any) {
  if (payload.id && payload.context && storeInstance) {
    const notification = Notification.fromJS(payload)
    storeInstance.dispatch({
      context: notification.context,
      notification,
      type: ActionTypes.UpdateNotificationReceived,
    } satisfies IUpdateNotificationReceivedAction)
  }
}

function subscribe() {
  if (socket && token) {
    socket.emit(Events.Subscribe, token)
  }
}
